import {
  Col as AntdCol,
  ColProps as AntdColProps,
  Row as AntdRow,
  RowProps as AntdRowProps,
} from "antd";
import React from "react";

const Grid = ({ children }: { children: React.ReactNode }) => {
  return <div>{children}</div>;
};

Grid.Row = AntdRow;
Grid.Col = AntdCol;

export type ColProps = AntdColProps;
export type RowProps = AntdRowProps;

export default Grid;
